import { render, staticRenderFns } from "./BroadcastForm.vue?vue&type=template&id=65a8c9cc&"
import script from "./BroadcastForm.vue?vue&type=script&lang=js&"
export * from "./BroadcastForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports